//React
import React, { Component } from "react";
//React
//Images
//Images
//CSS
import "./CustomRedirector.css";
//CSS
//Modules
//Modules

class CustomRedirection extends Component<{ routeToNavigate: string }, {}> {
  timeOut: NodeJS.Timeout | undefined;
  componentDidMount() {
    this.timeOut = setTimeout(() => {
      window.location.href = this.props.routeToNavigate;
    }, 2000);
    if (window.innerWidth < 500) {
      window.scrollTo({ top: 127 });
    } else {
      window.scrollTo({ top: 50 });
    }
  }
  componentWillUnmount(): void {
    clearTimeout(this.timeOut);
  }
  render() {
    return (
      <div className="custom-redirector w-full">
        <h1>در حال انتقال </h1>
        <div className="sea">
          <div className="circle-wrapper">
            <div className="bubble"></div>
            <div className="submarine-wrapper">
              <div className="submarine-body">
                <div className="window"></div>
                <div className="engine"></div>
                <div className="light"></div>
              </div>
              <div className="helix"></div>
              <div className="hat">
                <div className="leds-wrapper">
                  <div className="periscope"></div>
                  <div className="leds"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <h2>
          <span role="img" aria-label="smile">
            😊
          </span>
          لطفا صبور باشید
          <span role="img" aria-label="smile">
            😊
          </span>
        </h2>
      </div>
    );
  }
}

export default CustomRedirection;
